
export const EVENT_CATEGORIES = {
  ASK_BREEDER_QUESTION: 'Ask Breeder Question',
  APPLY_TO_BREEDER: 'Apply to Breeder',
  ADVANCE_APPLICATION_STEP: 'Advance Application Step',
  SUBMIT_APPLICATION: 'Submit an Application',
  SEND_MESSAGE: 'Send a Message',
  BREEDER_SIGNUP: 'Breeder Signup',
  BREEDER_OPEN_SIGNUP_MODAL: 'Breeder Open Signup Modal',
  BREEDER_SUBMIT_APPLICATION: 'Breeder Submit Application',
  FILTER_TRANSPORTATION: 'filter_transportation',
  FILTER_LOCATION: 'filter_location',
  FILTER_AVAILABILITY: 'filter_availability',
  FILTER_HEALTH_TESTING: 'filter_health_testing',
  BREEDER_REQUEST_PAYMENT: 'breeder_payment_request',
  FOLLOW_BREED: 'follow_breed'
};

export const EVENT_ACTION_IDS = {
  ASK_BREEDER_QUESTION: 'AW-810213694/sEF2CKL54JMBEL7Cq4ID',
  APPLY_TO_BREEDER: 'AW-810213694/T9FjCNz82ZMBEL7Cq4ID',
  SUBMIT_APPLICATION: 'AW-810213694/luBRCN6s5ZUBEL7Cq4ID',
  BREEDER_SUBMIT_APPLICATION: 'AW-667038394/21vuCPqDzsMBELrliL4C',
  SEND_MESSAGE: 'AW-810213694/itt1CM_c2JUBEL7Cq4ID'
};

/**
 * DEPRECATED: use EVENT_CATEGORIES above instead
 */
export const FACEBOOK_EVENTS = {
  SUBMIT_APPLICATION: 'SubmitApplication'
};

export const ANALYTICS_PROVIDERS = {
  GA: 'Google',
  FB: 'Facebook',
  BING: 'Bing',
  AHOY: 'Ahoy'
};

export const AHOY_URLS = {
  visits: '/user_interactions/visits',
  events: '/user_interactions/events'
};
